export default __webpack_public_path__ + "static/media/Cessation Tools.9958618c.png";